var exports = {
  "slidein": "xaf9ae18d--2038e3--slidein",
  "pin": "xaf9ae18d--2038e3--pin",
  "square": "xaf9ae18d--2038e3--square",
  "blue": "xaf9ae18d--2038e3--blue",
  "green": "xaf9ae18d--2038e3--green",
  "pin_main": "xaf9ae18d--2038e3--pin_main",
  "pin_main_logo_redesign": "xaf9ae18d--2038e3--pin_main_logo_redesign",
  "badge": "xaf9ae18d--2038e3--badge",
};

module.exports = exports;
